import { formatDateSafe } from "./utils";

/**
 * DEV-365: label for the Rates tab "Effective" badge in a CLIENT context.
 * At the client level the badge shows the group's plan effective date
 * (client_plans.effective_date for the plan year being viewed), not the rate
 * version's date - that one stays internal to rate resolution. Calendar date
 * only (no timezone shift): "2026-11-01 07:00:00" -> "Nov 01, 2026".
 * Returns null when there's no usable date (render no badge, never a warning).
 */
export function clientPlanEffectiveLabel(value: string | null | undefined): string | null {
  const ymd = typeof value === "string" ? value.match(/^\d{4}-\d{2}-\d{2}/)?.[0] : undefined;
  if (!ymd) return null;
  const [y, m, d] = ymd.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  // Reject impossible dates like 2026-02-31 (Date would roll them over).
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null;
  return formatDateSafe(ymd);
}
